import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { withModal } from 'components/modal/ModalHOC';

import InsightsReportsQueriesModal from 'modules/insights/reports/components/queries/modals/InsightsReportsQueriesModal';
import InsightsReportsCallout from 'modules/insights/reports/components/callouts/InsightsReportsCallout';

import { __t, applyTranslations } from 'utils/language';
import { COLLABARY, CREATE, FIXED_TO_TOP, QUERY } from 'modules/insights/reports/utils/insights-reports';

import './insights-reports-callout-collabary.scss';

import type {
  GeneralProps,
  QuerySave,
  Report,
  ReportType
} from 'modules/insights/reports/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./insights-reports-callout-collabary.i18n.json'));

type Props = {
  report: Report,
  reportType: ReportType,
  onSaveQuery: (a: QuerySave) => void
};

const COLLABARY_MSG_KEY = 'collabary_common';
const MSG_KEY = 'insights_reports_callout_collabary';

const ActionButtonWithQueriesModal = withModal(ActionButton, {
  modalContent: InsightsReportsQueriesModal,
  width: 'small',
  positionOverride: FIXED_TO_TOP
});

class InsightsReportsCalloutCollabary extends React.PureComponent<Props> {
  getText(): GeneralProps {
    const { reportType } = this.props;

    return {
      header: __t(`${MSG_KEY}.header`, {
        reportType: __t(`${COLLABARY_MSG_KEY}.social.${reportType}`)
      }),
      body: __t(`${MSG_KEY}.body`),
      button: __t(`${MSG_KEY}.button`)
    };
  }

  renderLink(linkText: string): React.ReactNode {
    return (
      <a
        href="https://help.collabary.com/en/articles/2440882-creating-a-share-of-voice-report"
        className="insights-reports-callout-collabary__link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkText}
      </a>
    );
  }

  renderButton(buttonText: string | undefined): React.ReactNode {
    const { report, onSaveQuery } = this.props;

    return (
      <ActionButtonWithQueriesModal
        color="primary"
        className="insights-reports-callout-collabary__button"
        modalContentProps={{
          report,
          query: {},
          pageType: COLLABARY,
          sectionType: QUERY,
          actionType: CREATE,
          onSaveQuery
        }}
      >
        {buttonText}
      </ActionButtonWithQueriesModal>
    );
  }

  render(): React.ReactNode {
    const text = this.getText();

    return (
      <InsightsReportsCallout
        headerText={text.header}
        body={text.body}
        button={this.renderButton(text.button)}
        className="insights-reports-callout-collabary"
      />
    );
  }
}

export default InsightsReportsCalloutCollabary;
